import React from 'react';
import { Formik} from 'formik';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Nothing was happening on submit because all inputs set on initialValues need to have inputs, names and ids!!
export default function Register() {
    // https://formik.org/docs/overview

    const navigate = useNavigate();

    // it is important to note that Formik needs the input id and name to be exactly the same as the initialValues name
    return (
        <>

            <main className="Register">
                <h1 className="text-6xl font-bold">Register</h1>

                <section>
                    <article>
                        <Formik
                            validateOnChange={false}
                            validateOnBlur={false}
                            initialValues={{ firstName: '', lastName: '', patientNumber: '', phoneNumber: '', email: '', username: '', password: '' }}
                            validate={values => {
                                const errors = {};
                                if (!values.firstName) {
                                    errors.firstName = "First name is required.";
                                }
                                if (!values.lastName) {
                                    errors.lastName = "Last name is required.";
                                }

                                if (!values.email) {
                                    errors.email = "Email address is required.";
                                }

                                if (!values.patientNumber) {
                                    errors.patientNumber = "Patient number is required.";
                                }

                                if (!values.phoneNumber) {
                                    errors.phoneNumber = "Phone number is required.";
                                }

                                if (!values.email) {
                                    errors.email = "Email address is required.";
                                }

                                if (!values.username) {
                                    errors.username = "Username is required.";
                                }

                                if (!values.password) {
                                    errors.password = "Password is required.";
                                }
                                return errors;
                            }}
                            onSubmit={(values) => {
                                console.log(values);
                                axios.post('http://localhost:5000/Register', values)
                                    .then((response) => {
                                        if (response.status === 200) {
                                            navigate('/Login');
                                        }
                                    })
                                    .catch((error) => { 
                                        console.log(error);
                                    })
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                resetForm,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div>
                                        <label htmlFor="firstName">First Name:</label>
                                        <input type="text" name="firstName" id="firstName" onChange={handleChange} onBlur={handleBlur} value={values.firstName} placeholder="Your First Name*" />
                                        <div className="validator">
                                            {errors.firstName && touched.lastName && errors.firstName}
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="lastName">Last Name:</label>
                                        <input type="text" name="lastName" id="lastName" onChange={handleChange} onBlur={handleBlur} values={values.lastName} placeholder="Your Last Name*" />
                                        <div className="validator">
                                            {errors.lastName && touched.lastName && errors.lastName}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="email">Email Address:</label>
                                        <input type="email" name="email" id="email" onChange={handleChange} onBlur={handleBlur} values={values.email} placeholder="Your Email Address*" />
                                        <div className="validator">
                                            {errors.email && touched.email && errors.email}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="patientNumber">Patient Number:</label>
                                        <input type="text" name="patientNumber" id="patientNumber" onChange={handleChange} onBlur={handleBlur} values={values.patientNumber} placeholder="Your Patient Number*" />
                                        <div className="validator">
                                            {errors.patientNumber && touched.patientNumber && errors.patientNumber}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="phoneNumber">Phone Number:</label>
                                        <input type="text" name="phoneNumber" id="phoneNumber" onChange={handleChange} onBlur={handleBlur} values={values.phoneNumber} placeholder="Your Phone Number*" />
                                        <div className="validator">
                                            {errors.phoneNumber && touched.phoneNumber && errors.phoneNumber}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="username">Username:</label>
                                        <input type="text" name="username" id="username" onChange={handleChange} onBlur={handleBlur} values={values.username} placeholder="Your Username*" />
                                        <div className="validator">
                                            {errors.username && touched.username && errors.username}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="password">Password:</label>
                                        <input type="password" name="password" id="password" onChange={handleChange} onBlur={handleBlur} values={values.password} placeholder="Your Chosen Password*" />
                                        <div className="validator">
                                            {errors.password && touched.password && errors.password}
                                        </div>
                                    </div>
                                    <button type="submit" disabled={isSubmitting}>Register</button>

                                </form>
                            )}
                        </Formik>
                    </article>
                    <article>
                        <img src={require('../assets/images/ipad.png')} className="logo" />
                    </article>
                </section>
            </main>
        </>
    )
}